module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "vp-vehicle-movement"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("Planos "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Contrato " + _vm._s(_vm.contractId) + " "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Veículos "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Movimentação do veículo")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info-vehicle"
  }, [_c('p', {
    staticClass: "inline"
  }, [_vm._v("Placa: "), _c('span', [_vm._v(_vm._s(_vm.vehicle.plate))])]), _vm._v(" "), _c('p', {
    staticClass: "inline"
  }, [_vm._v("TAG N°: "), _c('span', [_vm._v(_vm._s(_vm.vehicle.tagSerialNumber))])]), _vm._v(" "), _c('p', {
    staticClass: "inline"
  }, [_vm._v("Modelo: "), _c('span', [_vm._v(_vm._s(_vm.vehicle.modelName))])]), _vm._v(" "), _c('p', {
    staticClass: "inline"
  }, [_vm._v("Marca: "), _c('span', [_vm._v(_vm._s(_vm.vehicle.brandName))])]), _vm._v(" "), _c('p', {
    staticClass: "inline"
  }, [_vm._v("Eixos: "), _c('span', [_vm._v(_vm._s(_vm.vehicle.categoryAxesName))])])]), _vm._v(" "), _c('div', {
    staticClass: "filter-box"
  }, [_c('div', {
    staticClass: "inline"
  }, [_c('div', {
    staticClass: "inline filter-inline"
  }, [_c('p', {
    staticClass: "no-margin inline"
  }, [_vm._v("Filtros")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-filter",
    class: {
      'active': _vm.lastDays == '31'
    },
    on: {
      "click": function($event) {
        return _vm.handleChangeDate('31')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "month",
      "value": "31",
      "checked": ""
    },
    domProps: {
      "checked": _vm.lastDays == '31'
    }
  }), _vm._v(" Mês\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-filter",
    class: {
      'active': _vm.lastDays == '7'
    },
    on: {
      "click": function($event) {
        return _vm.handleChangeDate('7')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "week",
      "value": "7"
    },
    domProps: {
      "checked": _vm.lastDays == '7'
    }
  }), _vm._v(" Semana\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-filter",
    class: {
      'active': _vm.lastDays == '1'
    },
    on: {
      "click": function($event) {
        return _vm.handleChangeDate('1')
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "day",
      "value": "1"
    },
    domProps: {
      "checked": _vm.lastDays == '1'
    }
  }), _vm._v(" Dia\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "inline"
  }, [_c('vue-date-picker', {
    attrs: {
      "type": "date",
      "range": "",
      "lang": _vm.lang,
      "formatter": _vm.momentFormat,
      "placeholder": "00/00/0000 - 00/00/0000"
    },
    on: {
      "change": _vm.handleChangeDate
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "inline pull-right margin-t5"
  }, [_vm._v("Total da consulta: "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.totalValue)))])])]), _vm._v(" "), (_vm.searchState == 'NOTFOUND') ? _c('p', {
    staticClass: "alert alert-warning margin-t10"
  }, [_vm._v("Nenhum dado encontrado no período.")]) : _vm._e(), _vm._v(" "), (_vm.searchState == 'ERROSEARCH') ? _c('div', {
    staticClass: "alert alert-danger margin-t10"
  }, [_c('ol', [_c('li', [_vm._v(_vm._s(_vm.messageError))])])]) : _vm._e(), _vm._v(" "), (_vm.searchState == 'FOUND') ? _c('div', {
    attrs: {
      "id": "summary-box"
    }
  }, _vm._l((_vm.summaryVP), function(s, index) {
    return _c('div', {
      staticClass: "content-box-npadd margin-b20"
    }, [_c('div', {
      staticClass: "toll-info-box"
    }, [_c('div', {}, [_c('div', {}, [_c('small', [_vm._v("De")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(s.origem.substring(0, s.origem.indexOf(','))))]), _vm._v(" "), _c('small', [_c('img', {
      attrs: {
        "src": "/static/icon-send.svg",
        "alt": "icon send"
      }
    }), _vm._v("\n              " + _vm._s(s.origem.substring(s.origem.indexOf(',') + 1, s.origem.indexOf(',') + 4)) + "\n            ")])]), _vm._v(" "), _c('div', {}, [_c('small', [_vm._v("para")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(s.destino.substring(0, s.destino.indexOf(','))))]), _vm._v(" "), _c('small', [_c('img', {
      attrs: {
        "src": "/static/icon-location.svg",
        "alt": "icon location"
      }
    }), _vm._v("\n              " + _vm._s(s.destino.substring(s.destino.indexOf(',') + 1, s.destino.indexOf(',') + 4)) + "\n            ")])])]), _vm._v(" "), _c('button', {
      staticClass: "no-btn",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          s.open = !s.open
        }
      }
    }, [_c('i', {
      staticClass: "icon-circle-right",
      class: s.open ? 'open' : ''
    })]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("\n            rota:\n            "), _c('span', [_vm._v(_vm._s(s.rota))])]), _vm._v(" "), _c('p', [_vm._v("\n            distância:\n            "), _c('span', [_vm._v(_vm._s(s.totalDistance) + " KM")])]), _vm._v(" "), _c('p', [_vm._v("\n            valor:\n            "), _c('span', [_vm._v(_vm._s(_vm._f("cents")(s.valorVP)))])]), _vm._v(" "), _c('p', [_vm._v("\n            expiração:\n            "), _c('span', [_vm._v(_vm._s(_vm._f("date")(s.expirationVP)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "table-toll-info",
      class: s.open ? 'open' : ''
    }, [_c('table', {
      staticClass: "table"
    }, [_vm._m(0, true), _vm._v(" "), _c('tbody', _vm._l((s.pracas), function(p, index) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(p.praca))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.concessionaria))]), _vm._v(" "), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(_vm._f("cents")(p.price)))])])
    }), 0)])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.summaryVP.length > 0) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 result-table-count"
  }, [_vm._v("\n        Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + " a " + _vm._s(_vm.page.lastIndexShown()) + " de um total de " + _vm._s(_vm.page.itemCount()) + "\n        encontrados.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('router-link', {
    staticClass: "btn no-btn btn-square margin-10",
    attrs: {
      "to": {
        name: 'aggregate-list',
        params: {
          contractId: 14591
        }
      },
      "tag": "button"
    }
  }, [_vm._v("\n          Voltar\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-center"
  }, [_c('pagination', {
    attrs: {
      "model": _vm.page
    },
    on: {
      "page-change": _vm.setCurrentPage
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Praça de pedágio")]), _vm._v(" "), _c('th', [_vm._v("Concessionária")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Valor")])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-4cf94050!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/aggregate/vp-vehicle-movement.vue
// module id = 2121
// module chunks = 1